import { v4 as uuidv4 } from 'uuid';

export function generateSessionId() {
  // Generate a shorter, more user-friendly ID
  return uuidv4().split('-')[0].toUpperCase();
}

export function validateSessionData(data) {
  if (!data.clues || !Array.isArray(data.clues)) {
    throw new Error('Invalid clues data');
  }
  
  if (data.clues.length < 3) {
    throw new Error('At least 3 clues are required');
  }
  
  for (const clue of data.clues) {
    if (!clue.clue || !clue.answer) {
      throw new Error('Each clue must have both question and answer');
    }
    
    if (clue.answer.length < 2 || clue.answer.length > 20) {
      throw new Error('Answer length must be between 2 and 20 characters');
    }
    
    if (!/^[a-zA-ZäöüÄÖÜß]+$/.test(clue.answer)) {
      throw new Error('Answers can only contain letters');
    }
  }
  
  return true;
}

export function sanitizeInput(input) {
  return input.trim().replace(/[<>]/g, '');
}